<div class="container-fluid">
    <div class="header-container">
        <div class="page-header" style="display: flex; align-items: center;">
            <a [routerLink]="['../pos-products']">
                <span pTooltip="{{ 'bikeshop.pos-products.back_to_products' | translate }}" tooltipPosition="left"
                      class="fa fa-chevron-left font-button"></span>
            </a>{{ 'bikeshop.pos_products.import-products' | translate }}
        </div>
    </div>

    <div class="flex">
        <div class="wizard">
            <ul>
                <li>
                    <a class="first">
            <span class="wizard-step" [ngClass]="{'active': step===1, 'complete' : step > 1}">
              <span [ngClass]="{'inner-circle':step === 1}"></span>
              <span [ngClass]="{'hide':step > 1}"></span>
            </span>
                        <span class="wizard-title" [ngClass]="{'active': step===1, 'complete' : step > 1}">{{
                            'bikeshop.service_imports.step1' | translate}}</span>
                    </a>
                </li>
                <li>
                    <a>
            <span class="wizard-step" [ngClass]="{'active': step===2, 'complete' : step > 2}">
              <span [ngClass]="{'inner-circle':step === 2}"></span>
              <span [ngClass]="{'hide':step > 2}"></span>
            </span>
                        <span class="wizard-title" [ngClass]="{'active': step===2, 'complete' : step > 2}">{{
                            'bikeshop.service_imports.step2' | translate}}</span>
                    </a>
                </li>
                <li class="last">
                    <a>
            <span class="wizard-step" [ngClass]="{'active': step===3}">
              <span [ngClass]="{'inner-circle':step === 3}"></span>
              <span [ngClass]="{'hide':step > 3}"></span>
            </span>
                        <span class="wizard-title" [ngClass]="{'active': step===3, 'complete' : step > 2}">{{
                            'bikeshop.service_imports.step3' | translate}}</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>

    <div *ngIf="invalidFileFormat"
         class="validation-issues">{{ "bikeshop.service_imports.invalid_file_format" | translate }}</div>
    <div class="margin-top-16 content download-container" *ngIf="step === 1">
        <div>
            <div>
                <a href="/assets/excel-templates/Product Import Template.xlsx" target="_blank"
                   download="Product Import Template.xlsx">
                    <button pButton class="full-width"
                            label="{{ 'bikeshop.service_imports.download_template' | translate }}"></button>
                </a>
            </div>
            <div class="margin-top-16">
                <button pButton class="full-width accent"
                        label="{{ 'bikeshop.service_imports.select_file' | translate }}"
                        (click)="fileUpload.click()"></button>
                <input #fileUpload type="file" accept=".xlsx" style="display: none;" (change)="prepareFile($event)">
            </div>
        </div>
    </div>

    <div class="content margin-top-16 margin-bottom-16" *ngIf="step == 2">
        <div class="validation-issues" *ngIf="hasValidationErrors">
            {{ 'bikeshop.service_imports.has_validation_errors' | translate }}
        </div>

        <p-table #servicesTable 
        [columns]="columns" 
        [value]="data"
        [paginator]="true"
        [rows]="500">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''"
                        [ngStyle]="{'width': col.field === 'Notes' ? '250px' : 'auto'}">
                        {{col.header}}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-service let-columns="columns">
                <tr [pSelectableRow]="service">
                    <td *ngFor="let col of columns" [ngClass]="{ 'invalid-row' : service['Status'] !== 'Valid' }">
                        <div>
                            <ul *ngIf="col.type === 'barcodeSummary'" [innerHTML]="service[col.field]"
                                class="barcode-summary"></ul>
                        </div>
                        <div *ngIf="col.type === 'status' && service[col.field] === 'Valid'">
                            <span class="fa fa-check-square-o"></span>
                        </div>
                        <div>
                            <ul *ngIf="col.type === 'status' && service[col.field] !== 'Valid'"
                                [innerHTML]="service[col.field]" class="invalid"></ul>
                        </div>
                        <div *ngIf="col.type !== 'status' && col.type !== 'barcodeSummary'">
                            {{
                            col.type === "currency" && service[col.field] && service[col.field].length > 0
                                ? (service[col.field] | currencyVAT : countryData.currencySymbol) :
                                col.type === "boolean"
                                    ? (service[col.field] === true ? "Yes" : "No") :
                                    service[col.field]
                            }}
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <div class="loading" *ngIf="loading">
            <div class="loader"></div>
        </div>
    </div>

    <div class="content margin-top-16 margin-bottom-16" *ngIf="step == 3">

        <div class="margin-bottom-16">
            <p-progressBar [value]="progress"></p-progressBar>
        </div>
        <div *ngIf="importSummary.done" class="import-summary">
            <div>{{'bikeshop.pos-products.import_summary'| translate}}</div>
            <ul>
                <li>{{'bikeshop.pos-products.products_added' | translate}} - {{importSummary.added}}</li>
                <li>{{'bikeshop.pos-products.products_updated' | translate}} - {{importSummary.updated}}</li>
                <li>{{'bikeshop.pos-products.errors' | translate}} - {{importSummary.errors}}</li>
            </ul>
        </div>

        <p-table #servicesTable 
        [columns]="columnsImported" 
        [value]="importData"
        [paginator]="true"
        [rows]="500">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''">
                        {{col.header}}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-service let-columns="columns">
                <tr [pSelectableRow]="service">
                    <td *ngFor="let col of columns" [ngClass]="{ 'invalid-row' : service['Status'] !== 'Valid' }"
                        [ngStyle]="{'width': col.field === 'Notes' ? '250px' : 'auto'}">
                        <div>
                            <ul *ngIf="col.type === 'barcodeSummary'" [innerHTML]="service[col.field]"
                                class="barcode-summary"></ul>
                        </div>
                        <div *ngIf="col.type === 'status' && service['Imported'] === null">
                            <span class="fa fa-spinner fa-pulse"></span>
                        </div>
                        <div *ngIf="col.type === 'status' && service['Imported'] === true">
                            <span class="fa fa-check-square-o"></span>
                        </div>
                        <div *ngIf="col.type === 'status' && service['Imported'] === false && service['Status'] !== '' ">
                            <ul [innerHTML]="service['Status'] | translate" class="invalid"></ul>
                        </div>
                        <div *ngIf="col.type !== 'status' && col.type !== 'barcodeSummary'">
                            {{
                            col.type === "currency" && service[col.field] && service[col.field].length > 0
                                ? (service[col.field] | currencyVAT : countryData.currencySymbol) :
                                col.type === "boolean"
                                    ? (service[col.field] === true ? "Yes" : "No") :
                                    service[col.field]
                            }}
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <div class="loading" *ngIf="loading">
            <div class="loader"></div>
        </div>
    </div>

</div>

<div class="bottom-sheet" *ngIf="step == 2">
    <div class="flex">

        <div class="right flex">
            <button pButton class="full-width alternate" (click)="resetWizard()"
                    label="{{ 'bikeshop.service_imports.reset_wizard' | translate }}"></button>
            <div style="min-width: 200px;margin-left: 32px">
                <button pButton class="full-width accent" (click)="beginImport()" [disabled]="loading"
                        label="{{ 'bikeshop.service_imports.begin_import' | translate }}"></button>
            </div>
        </div>
    </div>
</div>

<div class="bottom-sheet" *ngIf="step == 3 && !importing">
    <div class="flex">
        <div class="right flex">
            <button pButton class="full-width alternate" (click)="resetWizard()"
                    label="{{ 'bikeshop.service_imports.import_another_file' | translate }}"></button>
        </div>
    </div>
</div>
